export const isValidRegex = (term: string) => {
  try {
    new RegExp(term)
    return true
  } catch (e) {
    return false
  }
}
